"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _AlertCircle = _interopRequireDefault(require("../icons/AlertCircle"));
var _InformationCircle = _interopRequireDefault(require("../icons/InformationCircle"));
var _rtl = require("../utils/rtl");
var _mediaQuery = _interopRequireDefault(require("../utils/mediaQuery"));
const StyledAsterisk = _styledComponents.default.span.withConfig({
  displayName: "FormLabel__StyledAsterisk",
  componentId: "sc-14kkg44-0"
})(["", ""], ({
  theme,
  filled
}) => (0, _styledComponents.css)(["font-weight:", ";color:", ";font-size:", ";vertical-align:top;"], theme.orbit.fontWeightBold, !filled ? theme.orbit.colorTextError : theme.orbit.colorFormLabelFilled, theme.orbit.fontSizeFormLabel));
StyledAsterisk.defaultProps = {
  theme: _defaultTheme.default
};
const StyledInputErrorIcWrapper = _styledComponents.default.span.withConfig({
  displayName: "FormLabel__StyledInputErrorIcWrapper",
  componentId: "sc-14kkg44-1"
})(["", ";"], ({
  theme
}) => (0, _styledComponents.css)(["margin:", ";display:inline-flex;align-items:center;"], (0, _rtl.rtlSpacing)(`0 ${theme.orbit.spaceXXSmall} 0 0`)));
StyledInputErrorIcWrapper.defaultProps = {
  theme: _defaultTheme.default
};
const FormLabel = (0, _styledComponents.default)(({
  className,
  children,
  required,
  filled,
  dataTest,
  id,
  error,
  help,
  onMouseEnter,
  onMouseLeave,
  iconRef,
  inlineLabel,
  labelRef
}) => /*#__PURE__*/React.createElement("span", {
  className: className,
  "data-test": dataTest,
  id: id,
  ref: labelRef,
  onMouseEnter: onMouseEnter,
  onMouseLeave: onMouseLeave
}, !inlineLabel && (error || help) && /*#__PURE__*/React.createElement(StyledInputErrorIcWrapper, {
  ref: iconRef
}, error && /*#__PURE__*/React.createElement(_AlertCircle.default, {
  ariaLabel: "error",
  color: "critical",
  size: "small"
}), !error && help && /*#__PURE__*/React.createElement(_InformationCircle.default, {
  ariaLabel: "help",
  color: "info",
  size: "small"
})), required && !error && /*#__PURE__*/React.createElement(StyledAsterisk, {
  "aria-hidden": "true",
  filled: filled
}, "*"), /*#__PURE__*/React.createElement("span", null, children))).withConfig({
  displayName: "FormLabel",
  componentId: "sc-14kkg44-2"
})(["", ""], ({
  theme,
  filled,
  disabled
}) => (0, _styledComponents.css)(["display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";color:", ";line-height:", ";margin-bottom:", ";margin-", ":", ";", ""], theme.orbit.fontFamily, theme.orbit.fontSizeFormLabel, theme.orbit.fontWeightMedium, !filled || disabled ? theme.orbit.colorFormLabel : theme.orbit.colorFormLabelFilled, theme.orbit.lineHeightTextNormal, theme.orbit.spaceXXSmall, _rtl.left, theme.orbit.spaceXXSmall, _mediaQuery.default.desktop((0, _styledComponents.css)(["margin-", ":0;"], _rtl.left))));
FormLabel.defaultProps = {
  theme: _defaultTheme.default
};
var _default = FormLabel;
exports.default = _default;